import Base from './Base';

export default class Segment extends Base {
    constructor(item) {
        super(item);

        if (!item.filters) {
            this.filters = {
                filtersList: []
            };
        }
    }
}
